export const PATCH_ALIASES = {
  "0": "V11.0",
  "V0": "V11.0",
  "v0": "V11.0",
  "0.0": "V11.0",
  "V0.0": "V11.0",
  "v0.0": "V11.0",
  "1.0": "V11.1",
  "V1.0": "V11.1",
  "v1.0": "V11.1",
  "2.0": "V11.2",
  "V2.0": "V11.2",
  "v2.0": "V11.2",
  "3.0": "V11.3",
  "V3.0": "V11.3",
  "v3.0": "V11.3",
  "4.0": "V11.4",
  "V4.0": "V11.4",
  "v4.0": "V11.4",
  "5": "V11.5",
  "V5": "V11.5",
  "v5": "V11.5",
  "5.0": "V11.5",
  "V5.0": "V11.5",
  "v5.0": "V11.5",
  "6": "V11.6",
  "V6": "V11.6",
  "v6": "V11.6",
  "6.0": "V11.6",
  "V6.0": "V11.6",
  "v6.0": "V11.6",
  "7": "V11.7",
  "V7": "V11.7",
  "v7": "V11.7",
  "7.0": "V11.7",
  "V7.0": "V11.7",
  "v7.0": "V11.7",
};

export function normalizePatchVersion(version) {
  if (version === null || version === undefined) {
    return "";
  }

  const rawVersion = String(version).trim();
  if (!rawVersion) {
    return "";
  }

  if (PATCH_ALIASES[rawVersion]) {
    return PATCH_ALIASES[rawVersion];
  }

  const match = rawVersion.match(/^v?\s*(\d+)(?:\.(\d+))?$/i);
  if (!match) {
    return rawVersion;
  }

  const canonicalVersion = match[2] === undefined
    ? `V${Number(match[1])}`
    : `V${Number(match[1])}.${Number(match[2])}`;
  return PATCH_ALIASES[canonicalVersion] || canonicalVersion;
}

export function getPatchMajorVersion(version) {
  const normalizedVersion = normalizePatchVersion(version);
  const match = normalizedVersion.match(/^V(\d+)(?:\.\d+)?$/);

  if (!match) {
    return "";
  }

  return `V${Number(match[1])}`;
}

function getPatchSortKey(version) {
  const normalizedVersion = normalizePatchVersion(version);
  const majorVersion = getPatchMajorVersion(normalizedVersion);
  const majorNumber = Number(majorVersion.replace("V", "")) || -1;
  const isMajorGroup = normalizedVersion === majorVersion;
  const minorMatch = normalizedVersion.match(/^V\d+\.(\d+)$/);
  const minorNumber = minorMatch ? Number(minorMatch[1]) : -1;

  return {
    majorNumber,
    isMajorGroup,
    minorNumber,
    normalizedVersion,
  };
}

export function comparePatchVersions(leftVersion, rightVersion) {
  const left = getPatchSortKey(leftVersion);
  const right = getPatchSortKey(rightVersion);

  if (left.majorNumber !== right.majorNumber) {
    return left.majorNumber - right.majorNumber;
  }

  if (left.isMajorGroup !== right.isMajorGroup) {
    return left.isMajorGroup ? -1 : 1;
  }

  if (left.minorNumber !== right.minorNumber) {
    return left.minorNumber - right.minorNumber;
  }

  return left.normalizedVersion.localeCompare(right.normalizedVersion);
}

export function normalizePatchList(patches) {
  const normalizedPatches = Array.from(
    new Set(
      patches
        .map(normalizePatchVersion)
        .filter(Boolean)
    )
  );

  const majorGroups = normalizedPatches
    .map(getPatchMajorVersion)
    .filter(Boolean);

  return Array.from(new Set([...normalizedPatches, ...majorGroups]))
    .sort((a, b) => {
      const left = getPatchSortKey(a);
      const right = getPatchSortKey(b);

      if (left.majorNumber !== right.majorNumber) {
        return right.majorNumber - left.majorNumber;
      }

      if (left.isMajorGroup !== right.isMajorGroup) {
        return left.isMajorGroup ? -1 : 1;
      }

      if (left.minorNumber !== right.minorNumber) {
        return left.minorNumber - right.minorNumber;
      }

      return left.normalizedVersion.localeCompare(right.normalizedVersion);
    });
}
